import web from "@/core/middlewares/web";

let index = () => import(/* webpackChunkName: "groups" */ '@/views/forms/Index');
let edit = () => import(/* webpackChunkName: "groups" */ '@/views/forms/Edit');
let create = () => import(/* webpackChunkName: "groups" */ '@/views/forms/Create');
let fieldsIndex = () => import(/* webpackChunkName: "groups" */ '@/views/forms/fields/Index');
let fieldsEdit = () => import(/* webpackChunkName: "groups" */ '@/views/forms/fields/Edit');
let fieldsCreate = () => import(/* webpackChunkName: "groups" */ '@/views/forms/fields/Create');
let responsesIndex = () => import(/* webpackChunkName: "groups" */ '@/views/forms/responses/Index');
let responsesEdit = () => import(/* webpackChunkName: "groups" */ '@/views/forms/responses/Edit');

export default [
    {
        path: "forms",
        name: "forms.index",
        component: index,
        meta: {
            middleware: web,
            permissions: ['forms:viewAny'],
            title: "فرم ها"
        }
    },
    {
        path: "forms/:form",
        name: "forms.edit",
        component: edit,
        meta: {
            middleware: web,
            permissions: ['forms:update'],
            title: "ویرایش فرم"
        }
    },
    {
        path: "forms/create",
        name: "forms.create",
        component: create,
        meta: {
            middleware: web,
            permissions: ['forms:create'],
            title: "ایجاد فرم"
        }
    },
    {
        path: "forms/:form/fields",
        name: "forms.fields.index",
        component: fieldsIndex,
        meta: {
            middleware: web,
            permissions: ['forms:viewAny'],
            title: "فیلدهای فرم"
        }
    },

    {
        path: "forms/:form/fields/create",
        name: "forms.fields.create",
        component: fieldsCreate,
        meta: {
            middleware: web,
            permissions: ['forms:create'],
            title: "ایجاد فیلد "
        }
    },

    {
        path: "forms/:form/fields/:field",
        name: "forms.fields.edit",
        component: fieldsEdit,
        meta: {
            middleware: web,
            permissions: ['forms:update'],
            title: "ویرایش فیلد "
        }
    },
    {
        path: "forms/:form/responses",
        name: "forms.responses.index",
        component: responsesIndex,
        meta: {
            middleware: web,
            permissions: ['forms:responses'],
            title: "پاسخ‌های فرم"
        }
    },
    {
        path: "forms/:form/responses/:response",
        name: "forms.responses.show",
        component: responsesEdit,
        meta: {
            middleware: web,
            permissions: ['forms:responses'],
            title: "مشاهده پاسخ"
        }
    },
]
